/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { UsuarioLogin } from 'src/app/models/usuario-login'
import { Observable, Subscription } from 'rxjs'
import { UserLoginService } from 'src/app/services/usuario-login.service'
import { AuthService } from 'src/app/services/auth.service'
import { OAuthEvent } from 'angular-oauth2-oidc'

@Component({
  selector: 'unesp-core-home',
  templateUrl: './unesp-core-home.component.html',
  styleUrls: ['./unesp-core-home.component.css'],
})
export class UnespCoreHomeComponent implements OnInit, OnDestroy {
  private userSubscription!: Subscription

  constructor(
    private userLoginService: UserLoginService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.userSubscription = this.authService.oauthEvent.subscribe(async (event: OAuthEvent) => {
      if (event.type === 'token_received') {
        const state = this.authService.oauthState

        if (state && state !== 'undefined') {
          this.router.navigateByUrl(decodeURIComponent(state))
        }
      }
    })
  }

  login(): void {
    sessionStorage.clear()
    this.authService.login()
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe()
    }
  }

  get userLogin$(): Observable<UsuarioLogin | null> {
    return this.userLoginService.user$
  }
}
